import React from 'react';
import { useHistory } from 'react-router-dom';
import { getConfig } from '../../../../utils/config';
import moment from 'moment';
import { renderDate, truncate } from '../../../../helpers';

const RecentBlogs = ({ blogs }) => {
    const history = useHistory();
    const config = getConfig();

    const blogClickedHandler = (blogId) => {
        history.push(`/blogs/${blogId}`);
    };
    return (
        <>
            <div className={' hidden lg:block w-full  '}>
                <h1
                    className={
                        `${config?.blogs.fontHeading}
                        ${config?.blogs?.detailsPageBackgroundColor}` +
                        ' font-semibold text-primary text-lg tracking-wider px-4 py-2 uppercase mb-4 '
                    }
                    style={{
                        color: config?.blogs?.primaryColor
                    }}
                >
                    Recent Posts
                </h1>
                <div
                    className={
                        ` ${config?.blogs?.detailsPageBackgroundColor}` +
                        '  px-4'
                    }
                >
                    {blogs.map((data) => {
                        return (
                            <>
                                <div
                                    className={
                                        ' flex my-2 border-b-[1px] pb-1 h-[100px] cursor-pointer hover:shadow-inner'
                                    }
                                    onClick={() => blogClickedHandler(data.id)}
                                >
                                    <div className="w-[35%] xl:w-[30%] ">
                                        <img
                                            src={data.displayImageUrl}
                                            className="w-full py-2 xl:pr-3 h-full object-cover"
                                            alt="img"
                                        />
                                    </div>
                                    <div className="w-[65%] xl:w-[70%] mt-1 px-2 py-2">
                                        <h2
                                            className={`${
                                                config?.blogs.fontHeading
                                            } text-[16px] capitalize leading-5 font-semibold  ${
                                                config?.darkMode
                                                    ? 'text-primary'
                                                    : 'text-black'
                                            } `}
                                        >
                                            {truncate(data.heading, 8)}
                                        </h2>

                                        <p
                                            className={`${
                                                config?.blogs.fontBody
                                            } text-[13px] ${
                                                config?.darkMode
                                                    ? 'text-[#9b9b9b]'
                                                    : 'text-[#1c2936]'
                                            } 
                                            `}
                                        >
                                            {renderDate(
                                                data?.publishDate
                                                    ? data?.publishDate
                                                    : data?.updatedOn
                                            )}
                                        </p>
                                    </div>
                                </div>
                            </>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default RecentBlogs;
